import React from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from "axios";
import { Container, Grid, TextField, Button, InputLabel, MenuItem, FormControl, Select, ListSubheader, Typography, IconButton, Dialog, DialogActions, DialogContent } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const LineInformation = ({ open, entry, weekInfo, editEntry, deleteEntry, timesheetstatus, handleClose }) => {

    const closeModal = () => {
        handleClose();
    }

    const getTotalWeekHours = (obj) => {
        let sum = 0;
        for (const key in obj) {
            sum += obj[key];
        }
        return sum;
    }

    return (
        <Dialog open={open} fullWidth onClose={closeModal}>
            {entry && (<DialogContent>
                <Grid container spacing={0}>
                    <Grid item xs={11} md={11}>
                        <Typography color="textSecondary">Entry Information</Typography>
                        <br />
                        <table style={{ textAlign: "left" }}>
                            <tbody>
                                <tr>
                                    <td><strong>Project ID</strong></td>
                                    <td>{entry.projectId}</td>
                                </tr>
                                <tr>
                                    <td style={{ minWidth: 110 }}><strong>Project Name</strong></td>
                                    <td>{entry.projectName}</td>
                                </tr>
                                <tr>
                                    <td><strong>Task ID</strong></td>
                                    <td>{entry.taskID}</td>
                                </tr>
                                <tr>
                                    <td><strong>Task Name</strong></td>
                                    <td>{entry.taskName}</td>
                                </tr>
                                <tr>
                                    <td><strong>Work Code</strong></td>
                                    <td>{entry.workCode}</td>
                                </tr>
                            </tbody>
                        </table>
                    </Grid>
                    <Grid item xs={1} md={1}>
                        <IconButton onClick={closeModal} style={{ padding: "2px", color: "rgb(172, 5, 51)" }}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>

                <hr />
                <Typography color="textSecondary">Description</Typography>
                <p>{entry.description}</p>
                <hr />
                <Typography color="textSecondary">Registered Hours (week total: {getTotalWeekHours(entry.registeredHours)})</Typography>
                <br />
                <table style={{ width: "300px", marginLeft: "-8px" }}>
                    <thead>
                        <tr>
                            {weekInfo.showMon && (<th style={{ color: weekInfo.isWorkingMon ? "rgba(0, 0, 0, 0.87)": "red"}}>Mon</th>)}
                            {weekInfo.showTue && (<th style={{ color: weekInfo.isWorkingTue ? "rgba(0, 0, 0, 0.87)": "red"}}>Tue</th>)}
                            {weekInfo.showWed && (<th style={{ color: weekInfo.isWorkingWed ? "rgba(0, 0, 0, 0.87)": "red"}}>Wed</th>)}
                            {weekInfo.showThu && (<th style={{ color: weekInfo.isWorkingThu ? "rgba(0, 0, 0, 0.87)": "red"}}>Thu</th>)}
                            {weekInfo.showFri && (<th style={{ color: weekInfo.isWorkingFri ? "rgba(0, 0, 0, 0.87)": "red"}}>Fri</th>)}
                            {weekInfo.showSat && (<th style={{ color: "red"}}>Sat</th>)}
                            {weekInfo.showSun && (<th style={{ color: "red"}}>Sun</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ textAlign: "center" }}>
                            {weekInfo.showMon && (
                                <td
                                    style={{ visibility: entry.registeredHours.monday === 0 ? "hidden" : "visible" }}>
                                    {entry.registeredHours.monday}
                                </td>
                            )}
                            {weekInfo.showTue && (
                                <td
                                    style={{ visibility: entry.registeredHours.tuesday === 0 ? "hidden" : "visible" }}>
                                    {entry.registeredHours.tuesday}
                                </td>
                            )}
                            {weekInfo.showWed && (
                                <td
                                    style={{ visibility: entry.registeredHours.wednesday === 0 ? "hidden" : "visible" }}>
                                    {entry.registeredHours.wednesday}
                                </td>
                            )}
                            {weekInfo.showThu && (
                                <td
                                    style={{ visibility: entry.registeredHours.thursday === 0 ? "hidden" : "visible" }}>
                                    {entry.registeredHours.thursday}
                                </td>
                            )}
                            {weekInfo.showFri && (
                                <td
                                    style={{ visibility: entry.registeredHours.friday === 0 ? "hidden" : "visible" }}>
                                    {entry.registeredHours.friday}
                                </td>
                            )}
                            {weekInfo.showSat && (
                                <td
                                    style={{ visibility: entry.registeredHours.saturday === 0 ? "hidden" : "visible", color: "red" }}>
                                    {entry.registeredHours.saturday}
                                </td>
                            )}
                            {weekInfo.showSun && (
                                <td
                                    style={{ visibility: entry.registeredHours.sunday === 0 ? "hidden" : "visible", color: "red" }}>
                                    {entry.registeredHours.sunday}
                                </td>
                            )}
                        </tr>
                    </tbody>
                </table>
                <hr />
            </DialogContent>)}
            {/* <Button variant="outlined" onClick={closeModal} style={{ height: 60, color: "rgb(172, 5, 51)", width: "40%", maxWidth: "300px" }}>
                    Cancel
                </Button> */}


            {timesheetstatus !== "pending" && timesheetstatus !== "approved" && (
                <DialogActions>
                    <Button variant="outlined" fullWidth style={{ height: 60, marginLeft: 10, marginRight: 10, borderColor: "rgb(172, 5, 51)", color: "#212121" }} onClick={() => editEntry(entry)}>
                        <EditIcon style={{ marginRight: 10 }} /> Edit
                    </Button>
                    <Button variant='contained' fullWidth style={{ height: 60, marginRight: 10, backgroundColor: "rgb(172, 5, 51)" }} onClick={() => deleteEntry(entry)}>
                        <DeleteIcon style={{ marginRight: 10 }} /> Delete
                    </Button>
                </DialogActions>
            )}


        </Dialog>
    );
};

export default LineInformation;
